import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { FETCH_PROMOTIONS, MobileListingActionPayload, PAUSE_MOBILE_LISTING } from 'src/redux/promotionsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* PauseMobileListingFlow(action: PayloadAction<MobileListingActionPayload>): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const { motorbikeId, promotionId } = action.payload
    yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${motorbikeId}/mobile_listings/${promotionId}/pause`,
      api: 'market-api',
      method: POST,
      params: {}
    })
    yield put(FETCH_PROMOTIONS(motorbikeId))
    yield put(SHOW_TOAST({ message: t('my_vehicles.toast_promotion_paused') }))
  } catch {
    return
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* PauseMobileListingSaga(): Generator<any, void, any> {
  yield takeLatest(PAUSE_MOBILE_LISTING, PauseMobileListingFlow)
}
